export default __webpack_public_path__ + "static/media/RunHorseLight_3_3.e73b35a4.jpg";